<template>
    <div class="register absolute">

        <div class="whiteBg">
            <div class="title">Daftarkan Akun</div>
            <div class="list">
                <div class="item">
                    <div>
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-phone_"></use>
                        </svg>
                        <span class="chooseArea" @click="chooseArea()">
              <slot name="country_tel">+{{area}}</slot>
              <span><svg t="1566640213388" class="icon" viewBox="0 0 1024 1024" version="1.1"
                         xmlns="http://www.w3.org/2000/svg" p-id="2787" width="18" height="18">
                  <path
                          d="M512 721.5c-4.6 0-9.2-1.8-12.7-5.3l-383.1-383c-7-7-7-18.4 0-25.5s18.4-7 25.5 0L512 678.1l370.3-370.3c7-7 18.4-7 25.5 0 7 7 7 18.4 0 25.5l-383.1 383c-3.5 3.5-8.1 5.2-12.7 5.2z"
                          p-id="2788"></path>
                </svg></span>
            </span>
                        <input type="text" v-model="account" placeholder="8**********"/>
                    </div>
                </div>
                <!-- <div class="item">
                  <div class="align-left">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-code_1"></use>
                    </svg>
                    <input type="text" v-model="captcha" placeholder="verifikasi" class="codeIput" />
                    <button
                      class="code"
                      :disabled="disabled"
                      :class="disabled === true ? 'on' : ''"
                      @click="code"
                    >
                      {{ text }}
                    </button>
                  </div>
                </div> -->
                <div class="item">
                    <div>
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-code_"></use>
                        </svg>
                        <input :type="showPassword1 ? 'text' : 'password'" v-model="password" placeholder="Isi kata sandi Anda"/>
                        <i class="r-eye-icon" @click="togglePasswordVisibility(1)"><img :src="showPassword1?eye_src2:eye_src1"></i>
                    </div>
                </div>
                <div class="item">
                    <div>
                        <svg class="icon" aria-hidden="true">
                            <use xlink:href="#icon-code_"></use>
                        </svg>
                        <input :type="showPassword2 ? 'text' : 'password'" v-model="password2" placeholder="Konfirmasi sandi"/>
                        <i class="r-eye-icon" @click="togglePasswordVisibility(2)"><img :src="showPassword2?eye_src2:eye_src1"></i>
                    </div>
                </div>
                <!--<div class="item">
                  <div>
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-code_1"></use>
                    </svg>
                    <input type="password" v-model="verify" placeholder="Silakan masukkan kode verifikasi" />
                    <img id="verify_img" :src="verify_src" alt="verify" style="padding: 0;height: 34px;margin: 0;">
                  </div>
                </div>-->
            </div>
            <div class="logon" @click="toregister">Daftar</div>
            <div class="tip">
                Have an existing account?
                <span @click="$router.push({ name: 'Login' })" class="font-color-blue">Login</span>
            </div>
            <div class="tips">
                Dengan mengklik "daftar" kamu menyetujui syarat dengan Interesting mall
                <span @click="$router.push({ path: '/RegisterService' ,query:{id:10}})" class="font-color-blue">Kebijakan
          Privasi</span>

                <!--<span @click="$router.push({ name: 'RegisterService' ,query:{id:9}})" class="font-color-blue">Privacy Policy</span>-->
            </div>
            <div class="club-tip">
                <b style="font-weight: bold;text-align: center;color: red"><p>Hari jadi Grup IM yang ke-9!</p></b>
                <p>Bonus pendaftaran: <b>Rp20.000</b></p>
                <p>Bonus deposit pertama: <b>Rp10.000</b></p>
                <p>Bonus harian untuk klub: <b>Rp250.000</b></p>
                <p>Bonus beruntung tiga kali seminggu: <b>Rp1.000.000</b></p>
            </div>
        </div>
        <!-- <div class="bottom"></div> -->
    </div>
</template>

<script>
    import sendVerifyCode from "@mixins/SendVerifyCode";
    // import {registerVerify, register, register_new} from "@api/user";
    import {register_new} from "@api/user";
    // import {validatorDefaultCatch} from "@utils/dialog";
    // import attrs, {required, alpha_num, chs_phone} from "@utils/validate";
    import cookie from "@utils/store/cookie";
    import dayjs from "dayjs";

    export default {
        name: "Register",
        data() {
            return {
                showPassword1:false,
                showPassword2:false,
                eye_src1:require('../../assets/images/eye1.png'),
                eye_src2:require('../../assets/images/eye2.png'),
                type: 'register',
                account: '',
                captcha: '',
                password: '',
                password2: '',
                verify: '',
                area: '',
                verify_src: '',
                bomb_btn: false,
            }
        },
        mixins: [sendVerifyCode],
        mounted: function () {
            // this.verify_src = 'http://127.0.0.1:8082/api/register/getCaptcha'
            this.area = this.localStorage.get("Area") ? this.localStorage.get("Area") : this.localStorage.get("default_country_code");
        },
        watch: {
            $route() {
                // this.area = this.$route.params.tel?this.$route.params.tel:this.localStorage.get("default_country_code");
                this.area = this.localStorage.get("Area") ? this.localStorage.get("Area") : this.localStorage.get("default_country_code");
            },
        },
        methods: {
            togglePasswordVisibility(type) {
                if(type===1){
                    this.showPassword1 = !this.showPassword1
                }
                if(type===2){
                    this.showPassword2 = !this.showPassword2
                }
            },
            chooseArea: function () {
                this.$router.push({path: '/selectCode'})
            },
            //注册
            async toregister() {
                var that = this;
                // const { account, password } = that;

                if (this.password !== this.password2) {
                    return this.$dialog.toast({mes: "Kata sandi yang dimasukkan dua kali tidak konsisten"})
                }
                that.$dialog.loading.open('loading...')
                register_new({
                    account: that.area + that.account,
                    captcha: "",
                    password: that.password,
                    spread: cookie.get("spread")
                }).then(res => {
                    // console.log(res)
                    that.$dialog.loading.close()
                    that.$store.commit("LOGIN", res.data.token, dayjs(res.data.expires_time));
                    that.$router.replace({path: "/user/myPay",query:{r:1}});
                    that.$dialog.success(res.msg);
                }).catch(res => {
                    that.$dialog.loading.close();
                    that.$dialog.error(res.msg);
                    if(res.msg==='Pengguna sudah ada')
                        that.$router.replace({path: "/login"});
                });
                /*register({
                  account: that.area + that.account,
                  captcha: "",
                  password: that.password,
                  spread: cookie.get("spread")
                }).then(res => {
                    this.$dialog.loading.close()
                    that.$dialog.success(res.msg);
                    that.formItem = 1;
                    setTimeout(() => {
                      that.$router.push({ path: '/login' })
                    }, 500);
                  }).catch(res => {
                    this.$dialog.loading.close()
                    that.$dialog.error(res.msg);
                  });*/
            },
            //发送短信
            /*async code() {

                var that = this;

                if (!that.account) {
                    that.$dialog.error("Please Masukkan nomor telepon Anda");
                    return
                }
                let query = {
                    phone: that.area + that.account,
                    type: that.type
                }
                if (this.bomb_btn) {
                    return
                }
                this.$dialog.loading.open('loading')
                this.bomb_btn = true
                registerVerify(query)
                    .then(res => {
                        this.$dialog.loading.close()

                        this.bomb_btn = false
                        that.$dialog.success(res.msg);
                        that.sendCode();
                    })
                    .catch(res => {
                        this.bomb_btn = false
                        this.$dialog.loading.close()

                        that.$dialog.error(res.msg);
                    });
            },*/
        },

    };
</script>

<style scoped>
    .tips {
        height: 1.1rem;
        text-align: center;
        /* line-height: 1.05rem; */
        font-size: 0.3rem;
        color: #cccccc;
    }
    .r-eye-icon{
        float: right;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .club-tip{
        color: #cccccc;
    }
    .club-tip p{
        padding: 5px 1px;
        /*margin-top: 10px;*/
    }
</style>